import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=40c412d2&scoped=true&"
import script from "./wx.vue?vue&type=script&lang=js&"
export * from "./wx.vue?vue&type=script&lang=js&"
import style0 from "./wx.vue?vue&type=style&index=0&id=40c412d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c412d2",
  null
  
)

export default component.exports